module.exports = __webpack_public_path__ + "static/alex-royal-rangers-1-4aa42ba79e6ae468a8dad8b65f685bac.jpg";